import { render, staticRenderFns } from "./EditEventStep2.vue?vue&type=template&id=7bb07954&"
import script from "./EditEventStep2.vue?vue&type=script&lang=js&"
export * from "./EditEventStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports